// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TicketFloatPopup_wrapper__2ww83","notice":"TicketFloatPopup_notice__2-GFo"};